import { useMutation } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { Email, HttpResponse, SendEmailRequest } from "@/types";

export function useSendEmail() {
  return useMutation({
    mutationFn: async ({
      sendEmailRequest,
    }: {
      sendEmailRequest: SendEmailRequest;
      candidacyId?: string;
    }) => {
      const res = await guacHttpClient.post<
        Email,
        HttpResponse<Email>,
        SendEmailRequest
      >("emails", sendEmailRequest);
      return res.data;
    },
  });
}
